// Mi día · correo: the words for each failure, from the codes owner-space answers (pure, tested). Network, Gmail
// (Configuración's connection) and Airtable's configuration of Personal Connections are told apart, never guessed.

export const ERRORS = {
  not_connected: 'Gmail no está conectado. Conéctalo en Configuración › Integraciones.',
  reconnect_needed: 'Google ya no acepta la autorización de Gmail (se revocó o venció). Vuelve a conectarlo en Configuración › Integraciones.',
  google_network: 'Google no respondió. Vuelve a intentarlo.',
  users_unavailable: 'No se pudo leer la conexión de Gmail. Vuelve a intentarlo.',
  api_disabled: 'La API de Gmail no responde para esta conexión. Revisa la conexión en Configuración › Integraciones.',
  scope_insufficient: 'La conexión de Gmail no tiene permiso de lectura. Vuelve a conectarla en Configuración › Integraciones.',
  not_configured: 'Gmail no está configurado en este entorno.',
  registry_unavailable: 'No se pudo leer la lista de contactos y participantes registrados en Oike, así que no se puede saber qué correos mostrar. No es que no haya correos: volvé a intentarlo.',
};
export const errorText = (code) => ERRORS[code]
  || (/^google_gmail_429/.test(String(code)) ? 'Gmail pidió esperar un momento antes de seguir leyendo. Volvé a intentarlo en unos segundos.' : `No se pudieron leer los correos (código ${code}).`);

/** What the card says about the walk through the label (pure, tested): how many were read and how many left out. */
export function scanText(scan, labelName, shown) {
  if (!scan) return '';
  const read = `${scan.scanned} ${scan.scanned === 1 ? 'correo revisado' : 'correos revisados'} en «${labelName}»`;
  const out = scan.hidden ? ` · ${scan.hidden} de remitentes no registrados quedan fuera` : '';
  const end = scan.cursor ? ' · hay correos más antiguos sin revisar' : ' · etiqueta revisada completa';
  return `${shown} de personas registradas · ${read}${out}${end}.`;
}

/** Why the label was not saved, from what owner-space answered: network, Gmail or Airtable (never a guess). */
export function labelSaveError(e, previous) {
  const keep = `El cambio no se guardó: la etiqueta sigue siendo «${previous || 'la anterior'}».`;
  const d = e?.data || {};
  if (e?.code === 'network') return `${keep} No hubo conexión con Oike: revisá tu red y volvé a intentarlo.`;
  if (e?.code === 'mail_label_not_saved') {
    if (d.reason === 'gmail') return `${keep} ${errorText(d.gmail)}`;
    if (d.reason === 'field_missing') return `${keep} En Airtable falta el campo «${d.field}» en la tabla ${d.table}: pedíselo a Omni (docs/mi-espacio/airtable-schema.md). Gmail y Calendar no cambian.`;
    if (d.reason === 'option_missing') return `${keep} En Airtable, el campo «${d.field}» de ${d.table} no tiene la opción «${d.option}»: pedíselo a Omni.`;
    if (d.reason === 'airtable_permission') return `${keep} Oike no tiene permiso para escribir en la tabla ${d.table} de Airtable: revisá el acceso del token.`;
    if (d.reason === 'not_persisted') return `${keep} Airtable no conservó el valor del campo «${d.field}» en ${d.table}: revisá que sea un texto largo.`;
  }
  return `${keep} ${e?.message || ''}`.trim();
}
